import React from "react";
import "assets/css/safexpay-web.css";
import "./Registration.css";
import Spinner from "reactstrap/lib/Spinner";
import { Modal } from "reactstrap";
import { base_url } from "assets/utils/const";
class BankDetails extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      accountNumber: "",
      accountHolderName: "",
      ifscCode: "",
      errors: [],
      isLoaded: false,
      btype: "",
      meId: "",
      mobileNo: "",
      bankVerification: true,
      bankResponse: {},
      responseMessage: "",
      bankResponseFailed: false,
      authToken: localStorage.getItem("Authtoken"),
    };

    // this.handleInputChange = this.handleInputChange.bind(this);
  }

  componentDidMount() {
    if (!localStorage.getItem("Authtoken")) {
      window.location.href = "/login";
    }
    fetch(`${base_url}api/dmoAuthApi`, {
      method: "POST",
      headers: {
        "Access-Control-Allow-Origin": "*",
        "Access-Control-Allow-Methods":
          "GET, POST, PATCH, PUT, DELETE, OPTIONS",
        "Access-Control-Allow-Headers": "Origin, Content-Type, X-Auth-Token",
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        token: this.state.authToken,
      }),
    })
      .then((res) => res.json())
      .then((result) => {
        console.log("result", result);
        if (result.statusCode == "200") {
          const payloadDetails = JSON.parse(result.payLoad);
          console.log("payloadDetails", payloadDetails);
          this.setState({
            btype: payloadDetails.BusinessType,
            meId: payloadDetails.meId,
            mobileNo: payloadDetails["Mobile number"],
          });
        } else {
          if (
            result.payLoad === `Session Expired Please Login` ||
            result.payLoad === `Incorrect Token`
          ) {
            this.toggleModal("loginModal");
          }
        }
      });
  }
  handleLogin = () => {
    this.toggleModal("loginModal");
    window.location.href = "/login";
  };

  hasError = (key) => {
    return this.state.errors.indexOf(key) !== -1;
  };
  toggleModal = (state) => {
    this.setState({
      [state]: !this.state[state],
    });
  };
  handleInputChange = (event) => {
    var key = event.target.name;
    var value = event.target.value;
    var obj = {};
    obj[key] = value;
    this.setState(obj);
    if (this.state.errors.indexOf(key) !== -1) {
      let errors = this.state.errors;
      errors.splice(this.state.errors.indexOf(key), 1);
      this.setState(errors);
    }
  };

  handleSubmit = (event) => {
    event.preventDefault();
    this.setState({ isLoaded: true, bankResponseFailed: false });
    const {
      meId,
      btype,
      mobileNo,
      accountNumber,
      ifscCode,
      accountHolderName,
    } = this.state;

    fetch(`${base_url}api/addBene`, {
      method: "POST",
      headers: {
        "Access-Control-Allow-Origin": "*",
        "Access-Control-Allow-Methods":
          "GET, POST, PATCH, PUT, DELETE, OPTIONS",
        "Access-Control-Allow-Headers": "Origin, Content-Type, X-Auth-Token",
        Accept: "application/json",
        "Content-Type": "application/json",
        auth: this.state.authToken,
      },
      body: JSON.stringify({
        // me_id: "201901090003",
        me_id: meId,
        ag_id: "paygate",
        mobileNo: mobileNo,
        accountNo: accountNumber,
        ifscCode: ifscCode,
        accountHolderName: accountHolderName.trim(),
        bank_id: "1",
        country_CURRENCY: "INR",
      }),
    })
      .then((res) => res.json())
      .then(
        (result) => {
          this.setState({ isLoaded: false });
          if (result.statusCode === "200") {
            if (result.message === "SUCCESS") {
              this.setState({ responseMessage: result.payLoad });
            } else {
              this.setState({ responseMessage: result.payLoad });
            }
            this.setState({ bankVerification: false });

            // var btype = localStorage.getItem("btype");
          } else {
            if (result.statusCode == "400" && result.message === "Failed") {
              this.setState({ bankResponseFailed: true });
            }
            if (
              result.payLoad === `Session Expired Please Login` ||
              result.payLoad === `Incorrect Token`
            ) {
              this.toggleModal("loginModal");
              this.toggleModal("docDetails");
            }
            this.setState({ bankVerification: true });
          }

          // localStorage.setItem('umail', umail);
          // localStorage.setItem('btype', ubusiness);
        },
        (error) => {
          this.setState({ isLoaded: false });
          //alert('Failed');
          //window.location.href = "/thankyou";
        }
      );
  };
  handleNext = () => {
    const { btype } = this.state;
    if (btype == "Individual") {
      window.location.href = "/personalind";
    } else if (btype == "Proprietorship") {
      window.location.href = "/personalprop";
    } else if (btype == "Partnership/LLP") {
      window.location.href = "/personalpart";
    } else if (btype == "PrivateLtd./PublicLtd.") {
      window.location.href = "/personalpub";
    } else if (btype == "Trust/Society") {
      window.location.href = "/personalsoc";
    }
  };
  handleModal = (e) => {
    e.preventDefault();
    this.handleAccountNumber();
    this.handleName();
    this.handleIFSC();
    if (this.state.errors.length > 0) {
      return false;
    }
    this.toggleModal("docDetails");
  };
  handleName = () => {
    let errors = this.state.errors;
    this.setState({ accountHolderName: this.state.accountHolderName.trim() });
    const nameTest = /^[A-Za-z .-]{1,50}$/;
    if (!nameTest.test(this.state.accountHolderName.trim())) {
      errors.push("accountHolderName");
      this.setState({ errors });
    }
  };

  handleIFSC = () => {
    let errors = this.state.errors;
    this.setState({ ifscCode: this.state.ifscCode.trim() });
    const testNumber = /^[A-Z]{4}0[A-Z0-9]{6}$/;
    if (!testNumber.test(this.state.ifscCode.trim())) {
      errors.push("ifscCode");
      this.setState({ errors });
    }
  };

  handleAccountNumber = () => {
    let errors = this.state.errors;
    if (
      this.state.accountNumber.trim() === "" ||
      this.state.accountNumber.trim().length > 25
    ) {
      errors.push("accountNumber");
      this.setState({ errors });
    }
  };
  docType = () => {
    const { btype } = this.state;
    if (btype === "Proprietorship" || btype === "Individual") {
      return (
        <ul>
          <li>
            Address proof: Driving License/ Aadhar card/ Passport/ Voter Id
          </li>
          <li> Pan card</li>
        </ul>
      );
    } else if (
      btype === "Partnership/LLP" ||
      btype === "PrivateLtd./PublicLtd." ||
      btype === "Trust/Society"
    ) {
      return (
        <ul>
          <li>
            Director 1 Address proof: Driving License/ Aadhar card/ Passport/
            Voter Id
          </li>
          <li> Director 1 Pan card </li>
          <li>
            Director 2 Address proof: Driving License/ Aadhar card/ Passport/
            Voter Id
          </li>
          <li> Director 2 Pan card </li>
        </ul>
      );
    }
  };

  businessDoc = () => {
    const { btype } = this.state;
    if (btype === "Proprietorship") {
      return (
        <ul>
          <li>GST Certificate</li>
          <li> Company Pan card</li>
          <li>Udyog Aadhaar</li>
        </ul>
      );
    } else if (btype === "Partnership/LLP") {
      return (
        <ul>
          <li>GST Certificate</li>
          <li> Company Pan card</li>
          <li>Paternership Deed</li>
          <li>Corporate Identification number (CIN)</li>
        </ul>
      );
    } else if (btype === "PrivateLtd./PublicLtd.") {
      return (
        <ul>
          <li>GST Certificate</li>
          <li> Company Pan card</li>
          <li>Board Resolution</li>
          <li>Corporate Identification number (CIN)</li>
          <li>DIN</li>
          <li>Memorandum of Association</li>
          <li>Article of Associations</li>
          <li>Udyog Aadhaar</li>
        </ul>
      );
    } else if (btype === "Trust/Society") {
      return (
        <ul>
          <li>GST Certificate</li>
          <li> Company Pan card</li>
          <li>Trust Act Certificate</li>
          <li>Authorization Letter Or Board Resolution</li>
          <li>Trust Deed</li>
        </ul>
      );
    }
  };
  render() {
    return (
      <>
        <section className="dv-Registration-content">
          <div className="first-bg htg"></div>
          <div className="container">
            <div className="row">
              <div
                className="col-md-6 dv-instruction"
                data-aos="fade-right"
                data-aos-duration="1000"
              >
                <h1 className="section-heading">
                  Quick &amp; Easy Activation Process
                </h1>
                <div className="row">
                  <div className="col-md-4 pr-0">
                    <div className="dv-step completed">
                      <div className="step">Step 1</div>
                      <div className="text">
                        Check email for Username &amp; OTP.
                      </div>
                    </div>
                  </div>
                  <div className="col-md-4 pr-0">
                    <div className="dv-step completed">
                      <div className="step">Step 2</div>
                      <div className="text">
                        Enter Username &amp; OTP. <br />
                        Set a desirable password.
                      </div>
                    </div>
                  </div>
                  <div className="col-md-4 pr-0">
                    <div className="dv-step">
                      <div className="step">Step 3</div>
                      <div className="text">
                        Fill in all the details &amp; upload documents to start
                        activation process.
                      </div>
                    </div>
                  </div>
                </div>
                <ul className="tick mt-3 mr-5">
                  <li className="completed">
                    Business Overview <span className="hr-white"></span>{" "}
                  </li>
                  {/* <li className="completed">Business Contact Details <span className="hr-white"></span></li> */}
                  <li>
                    Bank Account Details <span className="hr-white"></span>
                  </li>
                  <li>Agreement &amp; KYC Documents</li>
                </ul>
              </div>
              <div
                className="col-md-6 form-div"
                data-aos="fade-up"
                data-aos-duration="1000"
              >
                <form
                  onSubmit={this.handleModal}
                  className="dv-login-form dv-form pt-5"
                >
                  {/* <div className="form-group">
                                        <label htmlFor="ddlBankName">Bank Name</label>
                                        <select className="custom-select" id="ddlBankName">
                                            <option>Please Select</option>
                                        </select>
                                    </div> */}
                  {/* <div className="form-group">
                                        <label htmlFor="ddlAccountType">Account Type</label>
                                        <select className="custom-select" id="ddlAccountType">
                                            <option>Please Select</option>
                                        </select>
                                    </div> */}
                  <div className="form-group">
                    <label htmlFor="txtAccountNumber">
                      Account Number<span className="red">*</span>
                    </label>
                    <input
                      type="number"
                      className={
                        this.hasError("accountNumber")
                          ? "form-control is-invalid"
                          : "form-control"
                      }
                      name="accountNumber"
                      value={this.state.accountNumber}
                      onChange={this.handleInputChange}
                      id="txtAccountNumber"
                      placeholder="Eg.00000659 "
                      onBlur={this.handleAccountNumber}
                    />
                    {this.hasError("accountNumber") && (
                      <small style={{ color: "red" }}>
                        Invalid account number.
                      </small>
                    )}
                  </div>
                  {/* <div className="form-group">
                                        <label htmlFor="txtReenterAccountNumber">Reenter Account Number</label>
                                        <input type="text" className="form-control" id="txtReenterAccountNumber" placeholder="Eg.00000659" />
                                    </div> */}
                  <div className="form-group">
                    <label htmlFor="txtAccountHoldersName">
                      Account Holder's Name<span className="red">*</span>
                    </label>
                    <input
                      type="text"
                      className={
                        this.hasError("accountHolderName")
                          ? "form-control is-invalid"
                          : "form-control"
                      }
                      name="accountHolderName"
                      value={this.state.accountHolderName}
                      onChange={this.handleInputChange}
                      id="txtAccountHoldersName"
                      placeholder="Eg. Rahul Gupta"
                      onBlur={this.handleName}
                    />
                    {this.hasError("accountHolderName") && (
                      <small style={{ color: "red" }}>
                        Invalid account holder's name.
                      </small>
                    )}
                  </div>
                  <div className="form-group">
                    <label htmlFor="txtIFSCCode">
                      IFSC Code<span className="red">*</span>
                    </label>
                    <input
                      type="text"
                      className={
                        this.hasError("ifscCode")
                          ? "form-control is-invalid"
                          : "form-control"
                      }
                      name="ifscCode"
                      value={this.state.ifscCode}
                      onChange={this.handleInputChange}
                      id="txtIFSCCode"
                      placeholder="BOB00000"
                      onBlur={this.handleIFSC}
                    />
                    {this.hasError("ifscCode") && (
                      <small style={{ color: "red" }}>Invalid IFSC code.</small>
                    )}
                  </div>
                  {/* <div className="form-group">
                                        <label htmlFor="txtBankCity">Bank City</label>
                                        <input type="text" className="form-control" id="txtBankCity" placeholder="Eg. Mumbai" />
                                    </div> */}

                  <div className="form-group mt-4 sm-btn d-none">
                    <button className="btn btn-next bl-btn-md">
                      Verify Details
                    </button>
                  </div>
                  <div className="btn-holder mt-5 text-center">
                    <button
                      type="submit"
                      id="btn-create-account"
                      name="btn-create-account"
                      className={
                        this.state.isLoaded
                          ? `btn btn-next btn-gradient disable-btn`
                          : `btn btn-next btn-gradient`
                      }
                    >
                      Save
                    </button>
                  </div>
                  {/* <div className="btn-holder mt-2 text-center">
                                        <a href="/success" className="btn btn-next btn-green">
                                            Confirmed &amp; Next
                                        </a>
                                    </div> */}

                  <div className="dv-bottom-bg mt-5">
                    <div className="dv-help">
                      Need help?{" "}
                      <a href="/support" className="lnk-contact text-underline">
                        SUPPORT
                      </a>
                    </div>
                    <div className="first-bottom-bg"></div>
                    <div className="second-bottom-bg"></div>
                  </div>
                </form>
              </div>
            </div>
          </div>
          <Modal
            className="modal-dialog-centered modal-lg loginModal"
            isOpen={this.state.docDetails}
            toggle={() => this.toggleModal("docDetails")}
            backdrop={false}
            keyboard={false}
          >
            <div className="modal-body p-4 modal-shadow">
              <button
                aria-label="Close"
                className="close"
                data-dismiss="modal"
                type="button"
                onClick={() => this.toggleModal("docDetails")}
              >
                <span aria-hidden={true} className="close-btn-align">
                  ×
                </span>
              </button>
              <h5 style={{ textAlign: "center" }}>Please note:</h5>
              <p>
                The following documents will be needed for you to securely
                complete your KYC process in the next steps. Please have these
                documents handy before proceeding to the next page.
              </p>
              <h5>Personal documents</h5>
              {this.docType()}
              {this.state.btype !== "Individual" && <h5>Business documents</h5>}
              {this.businessDoc()}

              {this.state.responseMessage && (
                <p
                  style={{ textAlign: "center", fontSize: "1rem" }}
                  className="text-underline"
                >
                  {this.state.responseMessage}
                </p>
              )}
              {this.state.bankResponseFailed && (
                <p className="err" style={{ textAlign: "center" }}>
                  Bank details already added please use another bank details.
                </p>
              )}
              <div className="btn-holder mt-3 text-center">
                {!this.state.bankVerification ? (
                  <button
                    onClick={this.handleNext}
                    className="btn btn-gradient bt-wd"
                  >
                    Next
                  </button>
                ) : (
                  <button
                    onClick={this.handleSubmit}
                    className="btn btn-gradient bt-wd"
                    disabled={this.state.isLoaded}
                  >
                    Verify
                    {this.state.isLoaded ? (
                      <Spinner size="sm" color="light" className="btn-loader" />
                    ) : null}
                  </button>
                )}
              </div>
            </div>
          </Modal>
          <Modal
            className="modal-dialog-centered modal-lg loginModal"
            isOpen={this.state.loginModal}
            toggle={() => this.toggleModal("loginModal")}
            backdrop={false}
            keyboard={false}
          >
            <div className="modal-body p-4">
              {/* <button
                aria-label="Close"
                className="close"
                data-dismiss="modal"
                type="button"
                onClick={() => this.toggleModal("loginModal")}
              >
                <span aria-hidden={true} className="close-btn-align">
                  ×
                </span>
              </button> */}
              <h5 style={{ textAlign: "center" }}>
                Session Expired, Please Login to continue
              </h5>
              <div className="btn-holder mt-3 text-center">
                <button
                  onClick={this.handleLogin}
                  className="btn btn-gradient bt-wd"
                >
                  Login
                </button>
              </div>
            </div>
          </Modal>
        </section>
      </>
    );
  }
}

export default BankDetails;
